import { defineComponent as _defineComponent } from 'vue'
import { IBus, IBusLocation } from "@/domain/entities/lineInfo";

import { computed, PropType } from "vue";


const __default__ = {
  name: "MultiBusIndicator",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  busLocations: {
    type: Array as PropType<IBusLocation[]>,
    required: true,
  },
  selectedBus: {
    type: Object as PropType<IBusLocation>,
  },
  allBusesMap: {
    type: Object as PropType<Map<string, IBus>>,
  },
  isFullSeat: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClick"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const emitOnClick = (busesImageExisted: IBus[]) => {
  emit("onClick", busesImageExisted);
};

/** 아이콘으로 표시될 버스 정보 */
const displayedBusLocation = computed(() => {
  if (!props.selectedBus) {
    return props.busLocations[0];
  }

  const target = props.busLocations.find(
    (location) => location.allocUid === props.selectedBus?.allocUid
  );
  if (target) {
    return target;
  }

  return props.busLocations[0];
});

/** 이미지를 갖고 있는 버스 배열 */
const busesImageExisted = computed(() => {
  const buses: IBus[] = [];

  props.busLocations.forEach((location) => {
    const target = props.allBusesMap?.get(location.allocUid);
    if (target && !!target.busImages?.length) {
      buses.push(target);
    }
  });

  return buses;
});

const slicePlateNumber = (plateNumber: string) => {
  if (plateNumber.length > 4) return plateNumber.slice(-4);

  return plateNumber;
};

/** 펼침/닫힘 기능 삭제 */
// const isBusMultiple = computed(() => props.busLocations.length > 1);

// const isSpread = ref(false);
// const isAnimating = ref(false);
// const toggleCards = (toggle: boolean) => {
//   if (!isBusMultiple.value) return;

//   isAnimating.value = true;
//   isSpread.value = toggle;
// };

// const onTransitionEnd = () => {
//   isAnimating.value = false;
// };

// const cardWidth = 34;
// const calculateStyle = (index: number) => {
//   let zIndexValue;
//   if (isAnimating.value) {
//     zIndexValue = props.busLocations.length - index;
//   } else {
//     zIndexValue = isSpread.value ? index : props.busLocations.length - index;
//   }

//   return {
//     transform: `translateX(${isSpread.value ? index * (cardWidth + 4) : 0}px)`,
//     zIndex: zIndexValue,
//   };
// };

const __returned__ = { props, emit, emitOnClick, displayedBusLocation, busesImageExisted, slicePlateNumber }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})